import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const ImageModal = ({ url, title, children }) => {
  const [isOpen, setIsOpen] = useState(false);

  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  return (
    <>
      <div onClick={openModal} className="inline-block cursor-pointer">
        {children || (
          <img
            src={url}
            alt={title}
            className="rounded-lg shadow-md hover:shadow-xl transition w-full max-w-sm"
          />
        )}
      </div>

      <AnimatePresence>
        {isOpen && (
          <motion.div
            className="fixed inset-0 z-[999] bg-black bg-opacity-50 flex items-center justify-center"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={closeModal}
          >
            <motion.div
              className="bg-white rounded-xl overflow-hidden shadow-xl max-w-3xl w-full relative"
              initial={{ scale: 0.9 }}
              animate={{ scale: 1 }}
              exit={{ scale: 0.9 }}
              onClick={(e) => e.stopPropagation()}
            >
              <div className="flex justify-between items-center p-4 border-b">
                <h2 className="text-lg font-semibold">{title}</h2>
                <button
                  onClick={closeModal}
                  type='button'
                  className="text-gray-500 hover:text-gray-700 text-xl"
                >
                  &times;
                </button>
              </div>
              <div className="flex justify-center pb-6 pt-4 border border-gray-300">
                <img
                  src={url}
                  alt={title}
                  onError={({ currentTarget }) => {
                    currentTarget.onerror = null; // prevents looping
                    currentTarget.src ='/images/no-images.png';
                  }}
                  className=" max-h-[80vh] object-contain"
                  height={100}
                  width={700}
                />
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default ImageModal;
